import React from 'react';
import { motion } from 'framer-motion';

// Reusable scroll-triggered fade/slide wrapper
// Wrap any section to get a subtle entrance animation once it's 15% in view
const FadeInSection = ({
  children,
  delay = 0,
  direction = 'up',
  className = '',
  as = 'div'
}) => {
  const offset = {
    up: { y: 40, x: 0 },
    down: { y: -40, x: 0 },
    left: { x: 40, y: 0 },
    right: { x: -40, y: 0 },
    none: { x: 0, y: 0 }
  }[direction];

  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

export default FadeInSection;